module.exports = __webpack_public_path__ + "assets/img/icon-duo.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/family-plan/assets/images/icon-duo.png
// module id = 19
// module chunks = 0